import ModalCloseButton from '../../../../Component/UI/ModalCloseButton';
import styled from "styled-components";
import { modalProps } from "../../../../Component/Interface/Modal";
import {  RowView } from "../../../../Component/style/common_style";
import { amountFormat } from "../../../../Component/tool/Tools";
import moment from "moment";
import { useEffect, useState } from "react";
import api from "../../../../Component/axios_Interceptor/api";
import url from "../../../../Component/server";
import { useNavigate } from "react-router-dom";

import { PaymentPolicy } from '../Component/PaymentPolicyFields';

interface CoinPaymentModalProps extends modalProps {
  paymentPolicy?: PaymentPolicy;
  livedate: string[];
  live_start: Date;
  live_finish: Date;
  live_title: string;
  live_img: string;
  live_limit: number;
  secret_yn: boolean;
  cancel_ticket: number;
  shipping_mode: 'free' | 'fixed' | 'threshold';
  base_delivery_price: number;
  free_shipping_threshold: number | null;
  jeju_delivery_price: number;
  remote_delivery_price: number;
}

const CoinPaymentModal = ({
  paymentPolicy,
  visible,
  handleModal,
  livedate,
  live_start,
  live_finish,
  live_title,
  live_img,
  live_limit,
  secret_yn,
  cancel_ticket,
  shipping_mode,
  base_delivery_price,
  free_shipping_threshold,
  jeju_delivery_price,
  remote_delivery_price,
}: CoinPaymentModalProps) => {
  const closeModal = () => {
    handleModal();
  };

  const stopPropagation = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const Navigate = useNavigate();
  const [useCoin, setUseCoin] = useState(0);
  const [myCoin, setMyCoin] = useState<number | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    let active = true;
    setMyCoin(null);
    setErrorMessage("");
    const duration =
      moment(live_finish).diff(moment(live_start), "hours") || 24;
    setUseCoin(live_limit * duration * 114 / 25);
    if (visible) api.get(url.Communication_url.stock_coin).then(({ data }) => {
      if (data.coin == null || !Number.isFinite(Number(data.coin))) throw new Error("Invalid balance");
      if (active) setMyCoin(Number(data.coin));
    }).catch(() => {
      if (active) setErrorMessage("보유 코인을 불러오지 못했습니다. 창을 다시 열어주세요.");
    });
    return () => { active = false; };
  }, [visible, live_finish, live_start, live_limit]);

  const createLive = async () => {
    if (submitting) return;
    if (myCoin !== null && myCoin >= useCoin) {
      setSubmitting(true);
      setErrorMessage("");
      try {
        const res = await api.post(url.Communication_url.create_live, {
          ...paymentPolicy,
          live_start,
          live_finish,
          live_limit,
          live_title,
          live_img,
          secret_yn: secret_yn ? "y" : "n",
          log_type: "사용",
          log_con: "라이브 예약",
          coin: useCoin,
          cancel_ticket: cancel_ticket,
          shipping_mode,
          base_delivery_price,
          free_shipping_threshold,
          jeju_delivery_price,
          remote_delivery_price,
        }, { params: { returnDetail: '1' } });
        if (res.data?.message === "성공" && Number.isSafeInteger(res.data.seq)) {
          Navigate(`/admin/livelist/${res.data.seq}`);
        } else {
          setErrorMessage("예약 결과를 확인하지 못했습니다. 라이브 목록을 확인해주세요.");
        }
      } catch (error: any) {
        console.error("실패:", error);
        setErrorMessage(error?.response?.data?.message || "예약에 실패했습니다. 다시 시도해주세요.");
      } finally {
        setSubmitting(false);
      }
    }
  };

  return (
    <Container style={visible ? {} : { display: "none" }} onClick={closeModal}>
      <ModalBox onClick={stopPropagation}>
        <Title>
          <RowView>
            <div>타이틀</div>
            <ModalCloseButton tone="admin" aria-label="코인 결제 닫기" className="btn" onClick={handleModal} />
          </RowView>
        </Title>
        <ContentDiv>
          <RowView style={{ gap: 10 }}>
            <div>예약 일자</div>
            <div className="black">
              {livedate.length > 1
                ? `${moment(livedate[0]).format("YYYY.MM.DD")} ~ ${moment(livedate[1]).format("YYYY.MM.DD")}`
                : moment(livedate[0]).format("YYYY.MM.DD")}
            </div>
          </RowView>
          <RowView style={{ gap: 10 }}>
            <div>방송 시간</div>
            <div className="black">
              {amountFormat(
                moment(live_finish).diff(moment(live_start), "hours") || 24
              )}
              시간
            </div>
          </RowView>
          <RowView style={{ gap: 10 }}>
            <div>수용 인원</div>
            <div className="black">{amountFormat(live_limit)}명</div>
          </RowView>
          <Bar />
          <RowView style={{ width: "100%" }}>
            <div className="black">총 결제 코인</div>
            <div className="usecoin">{amountFormat(useCoin)}C</div>
          </RowView>
          <div className="mycoin">보유 코인 : {myCoin === null ? "확인 중" : `${amountFormat(myCoin)}C`}</div>
        </ContentDiv>
        <BtnDiv>
          <ApplyBtn
            disabled={myCoin === null || myCoin < useCoin || submitting}
            style={{
              cursor: myCoin !== null && myCoin >= useCoin ? "pointer" : "not-allowed",
              opacity: myCoin !== null && myCoin >= useCoin ? 1 : 0.5,
            }}
            onClick={createLive}
          >
            {submitting ? "예약 중..." : "결제하기"}
          </ApplyBtn>
        </BtnDiv>
        {errorMessage && <RedText role="alert">{errorMessage}</RedText>}
        {myCoin !== null && myCoin < useCoin && (
          <RedText>보유 코인이 부족합니다. 충전 후 다시 이용해주세요.</RedText>
        )}
      </ModalBox>
    </Container>
  );
};
export default CoinPaymentModal;

const Container = styled.div`
  z-index: 99;
  background-color: #00000085;
  position: fixed;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
`;

const ModalBox = styled.div`
  box-sizing: border-box;
  width: 95%;
  max-width: 25rem;
  margin: auto 0rem;
  background-color: var(--admin-theme-surface, white);
  color: var(--admin-ink);
  border-radius: 8px;
  padding: 24px;
  div.info {
    color: var(--admin-muted);
    font-size: 14px;
    text-align: center;
    line-height: 19px;
  }
  max-height: calc(100dvh - 32px);
  overflow-y: auto;
  overscroll-behavior: contain;
`;

const Title = styled.div`
  align-items: center;
  justify-content: flex-start;
  font-size: 20px;
  font-family: var(--font-family-base); font-weight: var(--font-weight-semibold);
  margin-top: 5px;
`;

const ContentDiv = styled.div`
  padding: 20px 8px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  font-size: 16px;
  font-family: var(--font-family-base); font-weight: var(--font-weight-regular);
  flex-direction: column;
  text-align: center;
  color: var(--admin-muted);
  gap: 10px;
  div.black {
    color: var(--admin-theme-text, black);
    font-family: var(--font-family-base); font-weight: var(--font-weight-medium);
  }
  div.usecoin {
    color: var(--admin-theme-danger, red);
    font-family: var(--font-family-base); font-weight: var(--font-weight-semibold);
    font-size: 20px;
  }
  div.mycoin {
    font-size: 14px;
    color: var(--admin-muted);
    align-self: flex-end;
    margin-bottom: 5px;
  }
`;

const BtnDiv = styled(RowView)`
  position: relative;
  width: 100%;
`;

const Btn = styled.button`
  border-radius: 8px;
  height: 48px;
  flex: 1;
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 16px;
  font-family: var(--font-family-base); font-weight: var(--font-weight-semibold);
  cursor: pointer;
  border: none;
`;

const ApplyBtn = styled(Btn)<{ disabled?: boolean }>`
  background: ${({ disabled }) =>
    disabled
      ? "linear-gradient(135deg, var(--admin-theme-raised, #f5f5f5), var(--admin-theme-raised, #f5f5f5))"
      : "linear-gradient(135deg, var(--admin-accent), var(--admin-accent-deep))"};
  color: ${({ disabled }) => (disabled ? "var(--admin-theme-text, #000000)" : "white")};
`;

const Bar = styled.div`
  width: 100%;
  height: 1px;
  background-color: var(--admin-theme-raised, #e8e8e8);
  margin: 5px 0px;
`;

const RedText = styled.div`
  font-size: 14px;
  color: var(--admin-theme-danger, red);
  text-align: center;
  margin-top: 10px;
`;
